export const UserTableConfig: NeoTableConfig = {
  title: "Users",
  table: {
    columns: [
      {
        uid: "name",
        name: "Name"
      },
      {
        uid: "userName",
        name: "User Name"
      },
      {
        uid: "userType",
        name: "User Type"
      },
      {
        uid: "gender",
        name: "Gender"
      },
      {
        uid: "parentName",
        name: "Parent Name"
      },
      {
        uid: "className",
        name: "Class / Department"
      },
      {
        uid: "sectionName",
        name: "Section"
      },
      {
        uid: "admissionNo",
        name: "Unique Code"
      },
      {
        uid: "phone",
        name: "Phone"
      },
      {
        uid: "dob",
        name: "Date of Birth"
      },
      {
        uid: "rfid",
        name: "RFID"
      },
      {
        uid: "uhfId",
        name: "UHF ID"
      },
      {
        uid: "pickup",
        name: "Pickup"
      },
      {
        uid: "drop",
        name: "Drop"
      },
      {
        uid: "empStopName",
        name: "Stop Name"
      },
      {
        uid: "empCategoryName",
        name: "Category"
      },
      {
        uid: "appStatus",
        name: "App Status"
      },
      {
        uid: "transport",
        name: "Transport user"
      },
      {name: "Actions", uid: "actions", type: "actions"}
    ],

    style: {
      height: "h-full"
    },
    activeColumns: [
      "name",
      "userName",
      "userType",
      "gender",
      "parentName",
      "className",
      "sectionName",
      "admissionNo",
      "phone",
      "dob",
      "rfid",
      "uhfId",
      "pickup",
      "drop",
      "appStatus",
      "transport",
      "actions"
    ],
    innerFilters: [
      {
        uid: "usersType",
        label: "User Type",
        type: "multiSelect",
        options: [
          {id: 1, name: "Parent"},
          {id: 2, name: "Staff"}
        ],
        defaultValue: [1, 2]
      }
    ],
    meta: {
      id: 1,
      title: "Manage Users",
      description: "Total Users",
      hasSearch: true,
      hasUpload: true,
      hasDownload: true,
      hasAdd: true,
      hasActions: true,
      hasCheckbox: false,
      hasFilter: true,
      hasFooter: true,
      hasHeader: true,
      hasPagination: true,
      hasCreate: true
    },
    url: {
      page: {
        view: "users/${navId}/view/user-details",
        add: "users/new/create/user",
        addOptions: [
          {
            key: "parent",
            label: "Parent User",
            description: "Create a parent with student details",
            path: "users/new/create/user"
          },
          {
            key: "staff",
            label: "Staff User",
            description: "Create a staff member",
            path: "users/new/create/staff"
          }
        ],
        edit: "users/${navId}/edit/user",
        editStaff: "users/${navId}/edit/staff"
      },
      api: {
        upload: "/api/users/upload",
        download: "/api/users/download",
        delete: "/api/users/delete",
        get: "/api/users/list",
        deactivate: "/api/users/status/update",
        resetpassword: "/api/users/password/reset",
        bpHistory: "/api/user/bp/history"
      }
    },
    actions: [
      {
        key: "edit",
        label: "Edit",
        type: "navigate",
        isVisible: true
      },
      {
        key: "view",
        label: "View",
        type: "navigate",
        isVisible: true
      },
      {
        key: "smart_edit",
        label: "Smart Edit",
        type: "modal",
        isVisible: false
      },
      {
        key: "reset_rfid",
        label: "Reset RFID",
        type: "modal",
        isVisible: true
      },
      {
        key: "resetpassword",
        label: "Reset Password",
        type: "modal",
        isVisible: false
      },
      {
        key: "deactivate",
        label: "Deactivate",
        type: "modal",
        isVisible: false
      },
      {
        key: "delete",
        label: "Delete",
        type: "modal",
        isVisible: false
      },
      {
        key: "bpHistory",
        label: "Boarding History",
        type: "modal",
        isVisible: true
      },
      {
        key: "activeandinactiveuser",
        label: "Active and Inactive user",
        type: "modal",
        isVisible: true
      }
    ]
  }
};
